import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import {

  urlAllSettingsSecured,
} from "../../api/urls";


export const allSettings = createAction("FILTER_SETTINGS", (filters, param) =>
  apiGet(urlAllSettingsSecured, param, false)()
);
